import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VisionIgniteWebinar.css";
import { FaUser, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const getNextSaturday = () => {

  const now = new Date();

  const next = new Date(now);

  const daysUntilSaturday =
    (6 - next.getDay() + 7) % 7;

  next.setDate(
    next.getDate() + daysUntilSaturday
  );

  next.setHours(17, 0, 0, 0);
  

  if (next <= now) {
    next.setDate(next.getDate() + 7);
  }

  return next;

};

const VisionIgniteWebinar = () => {

  // Hide website footer
  useEffect(() => {
    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");
  
   
    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";
  
    return () => {
      // 🔥 மீண்டும் restore
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);
  

  // Remove ElevenLabs widget
  useEffect(() => {

    const hideWidget = () => {

      document
        .querySelectorAll("elevenlabs-convai")
        .forEach(el => el.remove());

      document
        .querySelectorAll(
          "iframe,[class*='convai'],[id*='convai']"
        )
        .forEach(el => el.remove());

    };

    hideWidget();

    const interval =
      setInterval(hideWidget, 500);

    return () =>
      clearInterval(interval);

  }, []);

  // Scroll top

  useEffect(() => {

    window.scrollTo({

      top: 0,

      behavior: "smooth"

    });

  }, []);

  // Countdown target

  const [targetDate,
    setTargetDate] =
    useState(getNextSaturday());

  // Countdown

  const [countdown,
    setCountdown] =
    useState({

      days: 0,

      hours: 0,

      minutes: 0,

      seconds: 0

    });
    const [registered, setRegistered] = useState(false);

    const [registeredEmail, setRegisteredEmail] = useState("");
    const [registeredName, setRegisteredName] = useState("");

  // Blur Slider

  const [blur,
    setBlur] =
    useState(0);

  // Registered count

  const [weekCount,
    setWeekCount] =
    useState(0);

  // Registration popup

  const [showModal,
    setShowModal] =
    useState(false);

  // Form

  const [formData,
    setFormData] =
    useState({

      name: "",

      email: "",

      phoneNumber: ""

    });
  const TOTAL_SEATS = 10;

const [remainingSeats, setRemainingSeats] = useState(TOTAL_SEATS);
  const [loading,
    setLoading] =
    useState(false);

  // Countdown

  useEffect(() => {

    const timer =
      setInterval(() => {

        const now = new Date();

        const diff =
          targetDate - now;

        if (diff <= 0) {

          setTargetDate(
            getNextSaturday()
          );

          return;

        }

        setCountdown({

          days:
            Math.floor(
              diff /
              (1000 * 60 * 60 * 24)
            ),

          hours:
            Math.floor(
              diff /
              (1000 * 60 * 60)
            ) % 24,

          minutes:
            Math.floor(
              diff /
              (1000 * 60)
            ) % 60,

          seconds:
            Math.floor(
              diff /
              1000
            ) % 60

        });

      }, 1000);

    return () =>
      clearInterval(timer);

  }, [targetDate]);

  // Weekly registrations

  useEffect(() => {

    const loadCount =
      async () => {

        try {

          const res =
            await axios.get(
              "/api/vision-ignite-week-count"
            );

          setWeekCount(res.data.count);

          const seats = TOTAL_SEATS - res.data.count;

          // Never show less than 2 seats
          setRemainingSeats(
            seats <= 2 ? 2 : seats
          );

        }

        catch (err) {

          console.log(err);

        }

      };

    loadCount();

    const interval =
      setInterval(
        loadCount,
        5000
      );

    return () =>
      clearInterval(interval);

  }, []);

  // Lock page scroll while the popup is open

  useEffect(() => {

    document.body.style.overflow =
      showModal ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };

  }, [showModal]);

  // Close popup on Escape

  useEffect(() => {

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };

    document.addEventListener("keydown", onKeyDown);

    return () =>
      document.removeEventListener("keydown", onKeyDown);

  }, []);

  // Input

  const handleChange = e => {

    setFormData({

      ...formData,

      [e.target.name]:
      e.target.value

    });

  };

  // Register

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    setLoading(true);

    await axios.post(
      "/api/vision-ignite-webinar-register",
      formData
    );

    if (window.gtag) {
      window.gtag(
        "event",
        "vision_ignite_registration_success",
        {
          name: formData.name,
          page: "/vision-ignite-webinar",
        }
      );
    }

    setRegisteredEmail(formData.email);
    setRegisteredName(formData.name);

    setTimeout(() => {

  setLoading(false);

  // Decrease only until 2
  setRemainingSeats(prev => {

    if (prev <= 2) {
      return 2;
    }

    return prev - 1;

  });

  setRegistered(true);

}, 3000);

  } catch (err) {

    setLoading(false);

    alert(
      err.response?.data?.message ||
      "Registration Failed"
    );

  }
};

return (
  <div className="vision-webinar-page">

    <div className="page-layout">

      {/* ================= LEFT COLUMN ================= */}
     <div className="left-column">

  {/* HERO */}

  <section className="vi-hero">

    <div className="vi-left">

      <span className="vi-tag">
        🔴 FREE LIVE WEBINAR •{" "}
        {targetDate.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
        })}{" "}
        • 5 PM IST
      </span>

      <h1>
  Get rid of your
  <br />
  <span>glasses for life!!</span>
</h1>

<h4 className="hero-sub-heading">
  Use glasses as a fashion accessory,
  <br />
  not as a tool for a disability.
</h4>

      <p>
        Most people are told that once they start wearing glasses,
        there's no way back. We believe your vision deserves
        more than that conversation.
      </p>

    </div>

  </section>

  {/* MISSION */}

  <section className="mission-section">

    <div className="mission-card">

      <div className="mission-header">

        <span className="mission-icon">🎯</span>

        <h2>Our Mission</h2>

      </div>

      <h3>
        Help 100,000 people become less dependent on glasses
        through vision training.
      </h3>

      <p>
        Vision Ignite is more than a webinar.
        It's a movement to help people understand that vision
        is trainable, habits matter, and clearer sight
        is worth working towards.
      </p>

    </div>

  </section>

  {/* STATS */}

  <section className="stats-section">

    <div className="stat-card">

      <h3 className="desktop-stat">100,000</h3>
  <h3 className="mobile-stat">1L</h3>
  <p>People</p>


    </div>

    <div className="stat-card">

      <h3>1</h3>

      <p>Mission</p>

    </div>

    <div className="stat-card">

      <h3>Free</h3>

      <p>Live Webinar</p>

    </div>

  </section>

</div>


      {/* ================= RIGHT COLUMN ================= */}

      

        <aside className="register-right">
          <div className="register-card" id="register-form">

  {/* Top Date Bar */}
  {!loading && !registered && (

<div className="top-date-bar">

  <div className="date-item">
    <span className="date-icon">📅</span>
    <span>
      {targetDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })}
    </span>
  </div>

  <div className="date-divider"></div>

  <div className="date-item">
    <span className="date-icon">⏰</span>
    <span>5:00 PM IST</span>
  </div>

</div>

)}

  {loading ? (

    <div className="loading-screen">

      <div className="loader-circle">
        <div className="loader-ring"></div>
      </div>

      <h2 className="loading-title">
        Reserving Your Seat...
      </h2>

      <p className="loading-subtitle">
        Please wait while we secure your webinar seat.
      </p>

    </div>

  ) : registered ? (

    <div className="success-screen">

      <div className="success-icon-wrapper">
        <div className="success-icon">✓</div>
      </div>

      <h2 className="success-title">
        Registration Successful!
      </h2>

      <p className="success-text">
        Your webinar seat has been reserved successfully.
      </p>

      <div className="green-box">

        <div className="green-left">
          📩
        </div>

        <div className="green-right">

          <p>
            We will send your webinar joining link
          </p>

          <strong>
            1 hour before the webinar.
          </strong>

        </div>

      </div>

      <div className="info-card">

        <div className="row">

          <span>📅 Date</span>

          <strong>
            {targetDate.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
          </strong>

        </div>

        <div className="row">

          <span>⏰ Time</span>

          <strong>5:00 PM IST</strong>

        </div>

        <div className="row">

          <span>👤 Registered With</span>

          <strong>{registeredName}</strong>

        </div>

      </div>

      <div className="important-box">

        <h4>Important</h4>

        <p>
          Please check your Inbox and Spam folder.
        </p>

       

      </div>

    
    </div>

  ) : (

    <>

      <div className="countdown-card">

        <div className="count-header">

          <span className="pulse-dot"></span>

          STARTS IN

        </div>

        <div className="countdown">

          <div>
            <h2>{countdown.days}</h2>
            <span>Days</span>
          </div>

          <div>
            <h2>{countdown.hours}</h2>
            <span>Hours</span>
          </div>

          <div>
            <h2>{countdown.minutes}</h2>
            <span>Minutes</span>
          </div>

          <div>
            <h2>{countdown.seconds}</h2>
            <span>Seconds</span>
          </div>

        </div>

      </div>
      <h2 className="register-title">
       Join The Movement
      </h2>
      <h4 className="register-title">
  🔥 Only {remainingSeats} Seats Left!
    </h4>
    <p className="register-subtitle">
      Reserve your seat before today's webinar is full.
    </p>

      <form onSubmit={handleSubmit}>

  <div className="input-group">

    <FaUser className="input-icon" />

    <input
      type="text"
      name="name"
      placeholder="Your Name"
      value={formData.name}
      onChange={handleChange}
      required
    />

  </div>

  <div className="input-group">

    <FaEnvelope className="input-icon" />

    <input
      type="email"
      name="email"
      placeholder="Email Address"
      value={formData.email}
      onChange={handleChange}
      required
    />

  </div>

  <div className="input-group">

    <FaPhoneAlt className="input-icon" />

    <input
      type="text"
      name="phoneNumber"
      placeholder="Phone Number"
      value={formData.phoneNumber}
      onChange={handleChange}
      required
    />

  </div>

  <button
    type="submit"
    disabled={loading}
  >
    Book Your Seat Now
  </button>

</form>

      <p className="register-note">
        📩 Webinar joining link will be emailed
        <br />
        <strong>1 hour before the webinar.</strong>
      </p>

    </>

  )}

</div>
 

      </aside>

    </div>
  {/* ================= HOW IT WORKS ================= */}

<section className="vision-process-section">

  <div className="section-title">

    <h2>
      This Isn't About Selling Glasses.
    </h2>

    <p>
      It's about teaching you how to reduce unnecessary visual strain,
      train healthier visual habits, and build a long-term pathway
      toward greater freedom from glasses.
    </p>

  </div>

  <div className="process-grid">

    <div className="process-card">

      <div className="process-number">
        01
      </div>

      <h3>Measure</h3>

      <p>
        Understand how your eyes function beyond
        just your prescription and discover what may
        be limiting your visual performance.
      </p>

    </div>

    <div className="process-card">

      <div className="process-number">
        02
      </div>

      <h3>Train</h3>

      <p>
        Learn practical eye-training techniques that
        you can start practicing immediately to
        improve visual comfort and focus.
      </p>

    </div>

    <div className="process-card">

      <div className="process-number">
        03
      </div>

      <h3>Transform</h3>

      <p>
        Build daily habits that support clearer,
        stronger and more comfortable vision over
        the long term.
      </p>

    </div>

  </div>

</section>
{/* ================= FINAL CTA ================= */}

{/* ================= FINAL CTA ================= */}

<section className="final-cta-section">

  <div className="final-cta-card">

    <span className="final-tag">
      🚀 FREE LIVE WEBINAR
    </span>

    <h2>
      Your Glasses Don't Have To
      <br />
      Define The Rest Of Your Life.
    </h2>

    <p className="final-desc">
      Join hundreds of people learning natural vision training,
      healthy eye habits, and practical techniques to reduce
      unnecessary visual strain.
    </p>

    <div className="cta-highlights">

      <div className="highlight-item">
        <div className="highlight-icon">✅</div>
        <div>
          <h4>100% Free Session</h4>
          <p>No hidden charges</p>
        </div>
      </div>

      <div className="highlight-item">
        <div className="highlight-icon">👨‍🏫</div>
        <div>
          <h4>Live Q&A</h4>
          <p>Ask your questions live</p>
        </div>
      </div>

      <div className="highlight-item">
        <div className="highlight-icon">👁️</div>
        <div>
          <h4>Vision Training</h4>
          <p>Simple daily exercises</p>
        </div>
      </div>

      <div className="highlight-item">
        <div className="highlight-icon">📩</div>
        <div>
          <h4>Email Reminder</h4>
          <p>Link sent 1 hour before</p>
        </div>
      </div>

    </div>

    <div className="cta-note">

      <strong>
        Reserve your free seat today
      </strong>

      <span>
        Takes less than 10 seconds.
      </span>

      <button
        className="cta-register-btn"
        onClick={() => {

          document
            .getElementById("register-form")
            ?.scrollIntoView({

              behavior:"smooth"

            });

        }}
      >
        🚀 Reserve My Free Seat
      </button>

    </div>

  </div>

</section>
  </div>
);
};

export default VisionIgniteWebinar;
